export async function api(path, method = "GET", body) {
  let response;
  try {
    response = await fetch(`/api${path}`, {
      method,
      headers: { "Content-Type": "application/json", "X-RWY": "1" },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw Object.assign(new Error("网络未连接，已下载的经文仍可阅读"), {
      offline: true,
    });
  }
  const data = await response.json();
  if (!response.ok)
    throw Object.assign(new Error(data.error || "操作失败"), {
      status: response.status,
    });
  return data;
}
export const storage = {
  get(key, fallback) {
    try {
      return JSON.parse(localStorage.getItem(key)) ?? fallback;
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
};
